import { BoxProps, Flex, Text } from "@chakra-ui/react";
import { ShoppingPurchasedIcon } from "../../icons/ShoppingPurchasedIcon";
import { t } from "i18next";
import { ShoppingPurchasedThickIcon } from "../../icons/ShoppingPurchasedThickIcon";

interface AllReleasesOwnedBadgeProps extends BoxProps {
  /**
   * Size variant for different contexts
   * - "sm": Small variant for compact cards (11px text, 14px icon)
   * - "md": Medium variant for expanded cards (12px text, 16px icon)
   * - "lg": Large variant for bundle details (16px text, 24px icon)
   */
  size?: "sm" | "md" | "lg";

  /** Whether to use a thick icon */
  thickIcon?: boolean;
}

export function AllReleasesOwnedBadge({
  size = "md",
  thickIcon = false,
  ...boxProps
}: AllReleasesOwnedBadgeProps) {
  const iconSize = size === "sm" ? "18px" : size === "md" ? "24px" : "32px";
  const fontSize = size === "sm" ? "14px" : size === "md" ? "16px" : "24px";
  const gap = size === "sm" ? "6px" : "8px";

  return (
    <Flex alignItems="flex-start" gap={gap} {...boxProps}>
      {thickIcon ? (
        <ShoppingPurchasedThickIcon boxSize={iconSize} color="info.300" />
      ) : (
        <ShoppingPurchasedIcon boxSize={iconSize} color="info.300" />
      )}
      <Text fontSize={fontSize} fontWeight="500" color="neutral.300">
        {t("components.slideInMenu.bundleDetails.allReleasesOwned")}
      </Text>
    </Flex>
  );
}
